import { AuthService } from "./auth.service";
import { CheckForUpdate } from "./check-for-update.service";
import { LogUpdate } from "./log-update.service";
import { PromptUpdate } from "./prompt-update.service";
import { Log } from "./log.service";
import { Push } from "./push.service";
import { Seo } from "./seo.service";
import { UrlService } from "./url.service";

export default {
  AuthService,
  CheckForUpdate,
  PromptUpdate,
  LogUpdate,
  Log,
  Push,
  Seo,
  UrlService,
};

export const SERVICES = [
  AuthService,
  CheckForUpdate,
  PromptUpdate,
  LogUpdate,
  Log,
  Push,
  Seo,
  UrlService,
];
